module.exports = __webpack_public_path__ + "img/bg-methods.41b01a3e.svg";